export default {
    label_task:{
        en:"Dealer Bonus Slabs",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Bonus",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Bonus",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Bonus",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_percentage_bonus:{
        en:"Bonus Percentage",
        bn:'ব্যবহারকারীর বিবরণ'
    },


}